import { LocationStateType } from 'types/generic.types';
import { routes } from 'app/routing/routesConfig';
import { parse } from 'query-string';

interface GetRedirectPathProps {
  isMobile: boolean;
  locationState?: LocationStateType;
  search: string;
}

export const getRedirectPath = ({
  isMobile,
  locationState,
  search,
}: GetRedirectPathProps) => {
  const inviteToken = parse(search, { decode: false })?.inviteToken as string;

  if (isMobile) {
    return routes.settings.path;
  }

  if (inviteToken) {
    return routes.notifications.path;
  }

  return locationState?.from || routes.songs.path;
};
